export const STAGE_LOCAL = "STAGE_LOCAL";
export const STAGE_TEST = "STAGE_TEST";
export const STAGE_IMP = "STAGE_IMP";
export const STAGE_PROD = "STAGE_PROD";

export const getStage = (hostname: string): string => {
  if (hostname.match(/localhost/) || hostname.match(/127.0.0.1/)) {
    return STAGE_LOCAL;
  } else if (hostname.match(/test/) || hostname.match(/moss-mct-frontend/)) {
    return STAGE_TEST;
  } else if (hostname.match(/imp/)) {
    return STAGE_IMP;
  }

  return STAGE_PROD;
};
